module.exports = __webpack_public_path__ + "img/OREP_EO_logo.10c592b7.png";